<template>
  <div class="documents" ref="documents">
    <div class="card">
      <div class="card-content">
        <file-list :height="height" :viewer="viewer" :form="form" :selectable="selectable" has-chart />
      </div>
    </div>
  </div>
</template>

<script>
import FileList from "@/components/File/FileList";

export default {
  components: {
    FileList
  },
  data: () => ({
    height: 0,
    viewer: true,
    form: true,
    selectable: true,
  }),
  mounted() {
    this.height = this.$refs.documents.clientHeight - 36 // card content padding;
  }
};
</script>

<style lang="scss" scoped>
.documents {
  .card-content {
    height: calc(100vh - 50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Documents/list/index.vue